var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-card',[_c('div',{staticClass:"clearfix",attrs:{"slot":"header"},slot:"header"},[_c('span',[_vm._v("留言地区统计")])]),_c('ve-pie',{attrs:{"data":_vm.chartConf.data,"settings":_vm.chartConf.config}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }